import {
	AuthenticationDetails,
	CognitoUser,
	CognitoUserPool,
	CognitoUserSession,
} from 'amazon-cognito-identity-js';
import { navigate } from 'gatsby';

let completeNewPasswordChallengeUser: CognitoUser;
let completeNewPasswordChallengeUserAttributes: any;

export const cognitoSignIn = (
	userPool: CognitoUserPool,
	username: string,
	password: string
): Promise<CognitoUserSession> =>
	new Promise<CognitoUserSession>((resolve, reject) => {
		const cognitoUser = new CognitoUser({
			Username: username,
			Pool: userPool,
		});

		cognitoUser.authenticateUser(
			new AuthenticationDetails({
				Username: username,
				Password: password,
			}),
			{
				onSuccess: (result) => resolve(result),
				onFailure: (error) => {
					switch (error.code) {
						case 'PasswordResetRequiredException':
							navigate(
								`/change-password/?username=${encodeURIComponent(username)}&mode=forgot_password`
							);
							return;
						default:
							reject(error);
					}
				},
				newPasswordRequired: (userAttributes) => {
					completeNewPasswordChallengeUser = cognitoUser;
					completeNewPasswordChallengeUserAttributes = userAttributes;
					delete completeNewPasswordChallengeUserAttributes.email_verified;
					delete completeNewPasswordChallengeUserAttributes.email;
					navigate(
						`/change-password/?username=${encodeURIComponent(
							username
						)}&mode=complete_new_password_challenge`
					);
				},
			}
		);
	});

export const cognitoForgotPassword = (
	userPool: CognitoUserPool,
	username: string
): Promise<void> => {
	const cognitoUser = new CognitoUser({
		Username: username,
		Pool: userPool,
	});

	return new Promise((resolve, reject) => {
		cognitoUser.forgotPassword({
			onSuccess: () => resolve(),
			onFailure: (error) => reject(error),
		});
	});
};

export const cognitoCompleteNewPasswordChallenge = (newPassword: string): Promise<void> => {
	if (!completeNewPasswordChallengeUserAttributes || !completeNewPasswordChallengeUser)
		throw new Error('Not expecting a new password challenge');

	return new Promise((resolve, reject) => {
		completeNewPasswordChallengeUser.completeNewPasswordChallenge(
			newPassword,
			completeNewPasswordChallengeUserAttributes,
			{
				onSuccess: () => resolve(),
				onFailure: (error) => reject(error),
			}
		);
	});
};

export const cognitoConfirmPassword = (
	userPool: CognitoUserPool,
	username: string,
	newPassword: string,
	code: string
): Promise<void> => {
	const cognitoUser = new CognitoUser({
		Username: username,
		Pool: userPool,
	});

	return new Promise((resolve, reject) => {
		cognitoUser.confirmPassword(code, newPassword, {
			onSuccess: () => resolve(),
			onFailure: (error) => reject(error),
		});
	});
};

export const cognitoChangePassword = async (
	userPool: CognitoUserPool,
	oldPassword: string,
	newPassword: string
): Promise<void> => {
	const cognitoUser = userPool.getCurrentUser();
	if (!cognitoUser) throw new Error('Not Logged In');
	if (!oldPassword || !newPassword) throw new Error('Missing password');

	console.log(cognitoUser);

	return await new Promise((resolve, reject) => {
		cognitoUser.getSession((error: Error) => {
			if (error) reject(error);
			cognitoUser.changePassword(oldPassword, newPassword, (error) => {
				console.log(error);
				if (error) reject(error);
				resolve();
			});
		});
	});
};

export const getCognitoUserSession = async (
	userPool: CognitoUserPool
): Promise<CognitoUserSession | null> =>
	new Promise((resolve, reject) => {
		const cognitoUser = userPool.getCurrentUser();
		if (!cognitoUser) return resolve(null);

		cognitoUser.getSession((error: Error, session: CognitoUserSession | null) => {
			if (error) reject(error);
			if (!session || !session.isValid()) reject('Invalid Session');
			resolve(session);
		});
	});

export const cognitoSignOut = (userPool: CognitoUserPool) => userPool.getCurrentUser()?.signOut();
